import ConfirmationBillingSummary from '../ConfirmationBillingSummary/ConfirmationBillingSummary';
import styles from './ConfirmationRollup.module.scss';

/* ConfirmationRollup */
export default function ConfirmationRollup() {
  return (
    <div className={styles.confirmationRollup}>
      <div className={styles.confirmationCardHeader}>Your order</div>
      <ConfirmationBillingSummary showHotelLinks />
    </div>
  );
}
/* */
